import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PaginatedQueryModel } from '../models/paginatedQuery.model';
import { ClientModel } from '../models/client.model';
import { UpdatePassword } from 'src/app/login/change-password/models/password.model';
import { OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from '../../login/config/auth.config';
import { environment } from '../../../environments/environment';
import type { UserModel } from '../models/user.model';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/login/services/login.service';

@Injectable()
export class AuthService {
  apiRoot = '/auth';
  private user: UserModel;
  private userLogged$: BehaviorSubject<UserModel | null>;
  private isCurrentlyRunning = false;
  constructor(
    private http: HttpClient,
    private oauthService: OAuthService,
    private router: Router,
    private loginService: LoginService
  ) {
    this.userLogged$ = new BehaviorSubject<UserModel | null>(this.user);
    // this.userLogged$ = new Subject<UserModel>();
  }

  // private setUserLogged(): Observable<UserModel> {
  //   const userExist = localStorage.getItem('user');
  //   if (userExist) {
  //     // return of(JSON.parse(userExist));
  //     return this.userLogged$.asObservable();

  //   } else {
  //     const { sub, name, email } = this.getClaims();
  //     return new Observable<UserModel>(observer => {
  //       this.getUserByOIDC(sub).subscribe({
  //         next: user => {
  //           const fullUser = {
  //             id: user.user.id,
  //             name: name,
  //             username: email,
  //             role_id: user.user.role_id,
  //             client_id: user.user.client_id,
  //             role: user.user.role,
  //             client: user.user.client,
  //           };
  //           localStorage.setItem('user', JSON.stringify(fullUser));
  //           this.userLogged$.next(fullUser);
  //           this.user = fullUser;
  //           observer.next(fullUser);
  //           observer.complete();
  //         },
  //         error: error => {
  //           observer.error(error);
  //           observer.complete();
  //         },
  //       });
  //     });
  //   }
  // }

  public getUserLogged(): Observable<UserModel> {
    // this.setUserLogged();
    // return this.userLogged$.asObservable();
    const userExist = localStorage.getItem('user');
    if (userExist) {
      if (!this.user) {
        this.user = JSON.parse(userExist);
        this.userLogged$.next(this.user);
      }
    } else {
      if (!this.isCurrentlyRunning) {
        this.isCurrentlyRunning = true;
        const { sub, name, email } = this.getClaims();
        this.getUserByOIDC(sub).subscribe({
          next: user => {
            const fullUser = {
              id: user.id,
              name: name,
              username: email,
              role_id: user.role_id,
              client_id: user.client_id,
              role: user.role,
              client: user.client,
            };
            localStorage.setItem('user', JSON.stringify(fullUser));
            this.user = fullUser;
            this.userLogged$.next(fullUser);
            this.isCurrentlyRunning = false;
          },
          error: error => {
            this.isCurrentlyRunning = false;
          },
        });
      }
    }
    return this.userLogged$.asObservable();
  }

  // public getCurrentUser(): Observable<UserModel> | UserModel {
  //   if (!this.user) {
  //     this.setUserLogged().subscribe({
  //       next: user => {
  //         this.user = user;
  //       },
  //     });
  //     return this.userLogged$.asObservable();
  //   } else {
  //     const item = localStorage.getItem('user');
  //     this.user = JSON.parse(item);
  //     this.userLogged$.next(this.user);
  //     return this.user;
  //   }
  // }

  // public checkCurrentuser() {
  //   const item = localStorage.getItem('user');
  //   this.user = item ? JSON.parse(item) : undefined;
  //   this.userLogged$.next(this.user);
  //   return this.user;
  // }

  // OIDC
  public async configureAuth(): Promise<void> {
    this.oauthService.configure(authConfig);
    await this.oauthService.loadDiscoveryDocument();
    this.oauthService.setupAutomaticSilentRefresh();
  }

  // OIDC
  public getUserByOIDC(oneLoginId: number): Observable<UserModel> {
    return this.http.get<UserModel>(`${environment.apiAuthUrl}/api/onelogin/users/${oneLoginId}`, {
      headers: { validation: 'onelogin' },
    });
  }

  public getOAuthService(): OAuthService {
    return this.oauthService;
  }

  public getClaims(): Record<string, any> {
    return this.oauthService.getIdentityClaims();
  }

  public login(): void {
    this.oauthService.initCodeFlow(); // Initialized the flow of authorization
  }

  public logout(noRedirectToLogoutUrl?: boolean, preserveRedirectUrl = false): void {
    localStorage.removeItem('user');
    if (!preserveRedirectUrl) {
      sessionStorage.removeItem('postLoginRedirectUrl');
    }
    if (noRedirectToLogoutUrl) {
      this.oauthService.logOut(noRedirectToLogoutUrl);
      this.router.navigate(['error']);
    } else {
      const idToken = this.oauthService.getIdToken();
      if (idToken) {
        this.oauthService.logOut({
          idTokenHint: idToken,
          postLogoutRedirectUri: authConfig.postLogoutRedirectUri,
        }); // removes all tokens
      }
    }
  }

  public logoutOL(): Observable<any> {
    const refreshToken = sessionStorage.getItem('refresh_token');
    localStorage.removeItem('user');
    return this.http.post(`${environment.apiAuthUrl + this.apiRoot}/onelogin/logout`, { token: refreshToken });
  }

  public isLoggedIn(): boolean {
    // return this.oauthService.hasValidAccessToken() && this.oauthService.hasValidIdToken(); // verifies if user is authenticated, if token is valid returns true, otherwise false
    // se ha puesto la comprobacion a mano porque los methods comentados de arriba siempre daban true, aunque los timestamps fueran menores
    let isValidAccessToken = false;
    if (this.oauthService.getAccessToken()) {
      const expiresAt = sessionStorage.getItem('expires_at');
      const now = Date.now();
      isValidAccessToken = parseInt(expiresAt, 10) > now;
    }
    let isValidIdToken = false;
    if (this.oauthService.getIdToken()) {
      const expiresAt = sessionStorage.getItem('id_token_expires_at');
      const now = Date.now();
      isValidIdToken = parseInt(expiresAt, 10) > now;
    }
    return isValidAccessToken && isValidIdToken;
  }

  public getClientList(): Observable<PaginatedQueryModel<ClientModel>> {
    return this.http.get<PaginatedQueryModel<ClientModel>>(`${environment.apiAuthUrl}/api/onelogin/clients`);
  }

  // Admin user check (apiAuth)
  public checkAdminUser() {
    return this.http.get<any>(`${environment.apiAuthUrl}/validate/client/isadmin`);
  }

  public resetPassword(email: string) {
    const body = { email };
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.loginService.getPrivateToken()}`,
    });
    return this.http.post(`${environment.apiAuthUrl + this.apiRoot}/onelogin/forgot-password`, body, { headers });
  }

  public updatepassword(body: UpdatePassword) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.loginService.getPrivateToken()}`,
    });
    return this.http.patch<any>(`${environment.apiAuthUrl}/api/onelogin/users/password`, body, { headers });
  }
}
